import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router';
import { useAuthStore } from '@/stores/auth';
import { useProductStore } from '@/stores/product';
import { LoadingDots } from '@/components/common/LoadingDots';

export function GuestGuard() {
  const { isAuthenticated, isInitialized, initAuth, user } = useAuthStore();
  const { branding } = useProductStore();
  const [isChecking, setIsChecking] = useState(!isInitialized);

  useEffect(() => {
    if (!isInitialized) {
      void initAuth().finally(() => setIsChecking(false));
    }
  }, [isInitialized, initAuth]);

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg-base)]">
        <LoadingDots size="large" />
      </div>
    );
  }

  if (isAuthenticated()) {
    // Unverified email → email verification page
    if (user?.email_verified === false) {
      return <Navigate to="/verify-email" replace />;
    }
    // Needs onboarding → onboarding page
    if (user?.needs_onboarding) {
      return <Navigate to="/onboarding" replace />;
    }
    return <Navigate to={branding ? '/bi' : '/setup'} replace />;
  }

  return <Outlet />;
}
